module.exports = "https://web-assets.ifttt.com/packs/media/components/x-20a4e3de.svg";